import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input, OnInit, SimpleChanges } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { DatiAppuntamentiPerImpresa, DatiSopralluogoPerImpresa, PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-appuntamenti",
  templateUrl: "./home.appuntamenti.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeAppuntamentiFlowdy2Component implements OnInit {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;

  ref: DynamicDialogRef;

  protected datiRaggruppatiBando1: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando1Filtrati: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando2Filtrati: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando2: DatiAppuntamentiPerImpresa[] = [];

  protected labelRegioni:string = "TUTTE LE REGIONI";

  protected isLoading: boolean = true;
  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  
  protected isDipendente: boolean = true;
  protected hasBando1: boolean = false;
  protected hasBando2: boolean = false;
  
  protected filtroRegione: string[] = [];

  protected filterIsSet: boolean = false;


  protected selectedPraticaBando1KO: PraticaFlowdy2_Firestore;
  protected selectedPraticaBando2KO: PraticaFlowdy2_Firestore;

  protected totaliBando1:number = 0;
  protected totaliBando1NoAppuntamentoMancaPF_noNTW:number = 0;
  protected totaliBando1NoAppuntamentoMancaPF_conNTW:number = 0;
  protected totaliBando1NoAppuntamentoPFPronto:number = 0;
  protected totaliBando1AppuntamentoFissato:number = 0;
  protected totaliBando1AppuntamentoScaduto:number = 0;
  protected totaliBando1AttivazioneKO:number = 0;
  protected totaliBando1AttivazioneOK:number = 0;
  protected totaliBando1installazioneOK:number = 0;

  protected totaliBando2:number = 0;
  protected totaliBando2NoAppuntamentoMancaPF_noNTW:number = 0;
  protected totaliBando2NoAppuntamentoMancaPF_conNTW:number = 0;
  protected totaliBando2NoAppuntamentoPFPronto:number = 0;
  protected totaliBando2AppuntamentoFissato:number = 0;
  protected totaliBando2AppuntamentoScaduto:number = 0;
  protected totaliBando2AttivazioneKO:number = 0;
  protected totaliBando2AttivazioneOK:number = 0;
  protected totaliBando2installazioneOK:number = 0;



  protected activeTabIndex: number = 0; 

  private collection_pratiche:string  = environment.firebase.collection_pratiche;
  protected stats: StatsFlowdy2 = new StatsFlowdy2();

  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    public utilService:UtilService,
    public excelService:ExcelService,
    public listeService:ListeService,
    
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.logger.info("[HOME APPUNTAMENTI] ON INIT");
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index; 
  }

 
   ngOnChanges(changes: SimpleChanges) {
       
      if (changes['impresa'] && changes['impresa'].currentValue) {
        this.impresa = changes['impresa'].currentValue;
      }
      if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
        this.isImpresa = changes['isImpresa'].currentValue;
      }
      if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
        this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
      }
  
      if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
        this.loadDatiBando1();
        this.loadDatiBando2();
      }
    }

    scaricaReportSopralluoghi(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
       if(this.activeTabIndex == 0){
        this.excelService.exportAppuntamentiToExcel(this.datiRaggruppatiBando1Filtrati, `report_attivazioni_bando1_${formattedDate}.xlsx`);
      }else if(this.activeTabIndex == 1){
        this.excelService.exportAppuntamentiToExcel(this.datiRaggruppatiBando2Filtrati, `report_attivazioni_bando2_${formattedDate}.xlsx`);
      } 
    }

    openPraticheFase2DiImpresa(bando:number, idImpresa:number,impresa:string,statoAttivazione:string){
      switch (statoAttivazione) {
        case 'ALL':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                'impresa': idImpresa,
                'ragioneSocialeImpresa': impresa ,
              }, 
            }
          ));
          break;
          case 'noAppuntamentoMancaPF_noNTW':
          case 'noAppuntamentoMancaPF_conNTW':
          case 'noAppuntamentoPFPronto':
          case 'appuntamentoFissato':
          case 'appuntamentoScaduto':
          case 'attivazioneKO':
          case 'attivazioneOK':
          case 'installazioneOK':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 
                  'impresa': idImpresa ,
                  'ragioneSocialeImpresa': impresa ,
                  'statoAttivazione': statoAttivazione
                }, 
            }
          ));
          break;
        default:
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-2'],
            {
              queryParams: { 'impresa': idImpresa }, 
            }
          ));
          break;
      }
      
     
    }

    checkAppuntamentoPassato(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.dataAppuntamentoFase2){
        const oggi = new Date(); 
        const dataAppuntamentoDaControllare = new Date(pratica.dataAppuntamentoFase2.toDate().getFullYear(),  pratica.dataAppuntamentoFase2.toDate().getMonth(), pratica.dataAppuntamentoFase2.toDate().getDate() + 2); 
        if(pratica.dataAppuntamentoFase2 && !pratica.installazioneRouterOk ){
          if(dataAppuntamentoDaControllare < oggi){
            //this.logger.info(pratica.azienda + "-> checkAppuntamentoPassato per pratica "+ pratica.cui + " e data app " + dataAppuntamentoDaControllare +" APPP SCADUTO!");

            return true
          }
          return false;
        }
      }
        
        return false;
      
     }
    


    
    loadDatiBando1(){

      this.isLoading = true;
      
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando1  ;
      if(this.isImpresa){
        queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("azienda",'asc');
      }else{
        queryBando1 = collectionRef
                    .where("bando", "==", "BANDO 1")
             //       .where("statoFlowdyFase1", "!=", "SOPRALLUOGO KO")
                    .orderBy("statoFlowdyFase1")
                    .orderBy("azienda",'asc');
      }
      onSnapshot(queryBando1, (qs) => {
        this.isLoading = false;
        const raggruppamentoPerImpresa: { 
          [key: string]: { 
            idImpresa: number,
            totale: number,
            noAppuntamentoMancaPF_noNTW: number,
            noAppuntamentoMancaPF_conNTW: number,
            noAppuntamentoPFPronto: number,
            appuntamentoFissato: number,
            appuntamentoScaduto: number,
            attivazioneKO: number,
            attivazioneOK: number,
            installazioneOK: number,
            datiPerRegione: {
              [regione: string]: {
                totale: number;
                noAppuntamentoMancaPF_noNTW: number,
                noAppuntamentoMancaPF_conNTW: number,
                noAppuntamentoPFPronto: number,
                appuntamentoFissato: number,
                appuntamentoScaduto: number,
                attivazioneKO: number,
                attivazioneOK: number,
                installazioneOK: number,
              };
            };
          } 
        } = {};

        this.totaliBando1                         = 0;
        this.totaliBando1NoAppuntamentoMancaPF_noNTW    = 0;
        this.totaliBando1NoAppuntamentoMancaPF_conNTW    = 0;
        this.totaliBando1NoAppuntamentoPFPronto   = 0;
        this.totaliBando1AppuntamentoFissato      = 0;
        this.totaliBando1AppuntamentoScaduto      = 0;
        this.totaliBando1AttivazioneKO            = 0;
        this.totaliBando1AttivazioneOK            = 0;
        this.totaliBando1installazioneOK          = 0;
        let contatoreSITE = 0
          qs.forEach((doc) => {
            let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            const impresa = praticaBando1DaFirestore.azienda;
            const regione = praticaBando1DaFirestore.regione;
 
            if (!raggruppamentoPerImpresa[impresa]) {
             // this.logger.info(impresa + " @ "+ regione);
              raggruppamentoPerImpresa[impresa] = { 
                idImpresa: praticaBando1DaFirestore.idAzienda,
                totale: 0, 
                noAppuntamentoMancaPF_noNTW : 0,
                noAppuntamentoMancaPF_conNTW: 0,
                noAppuntamentoPFPronto: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                attivazioneKO: 0,
                attivazioneOK: 0,
                installazioneOK: 0,
                datiPerRegione: {},
              };
            }
          if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
                totale: 0,
                noAppuntamentoMancaPF_noNTW: 0,
                noAppuntamentoMancaPF_conNTW: 0,
                noAppuntamentoPFPronto: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                attivazioneKO: 0,
                attivazioneOK: 0,
                installazioneOK: 0,
              };
            } 
            
           
          /*   */
           /*   if(praticaBando1DaFirestore.azienda === 'COGEPA'){
                  this.logger.info("PRATICA DI COGEPA SENZA PF " + praticaBando1DaFirestore.cui + " - "+praticaBando1DaFirestore.codiceStatoInfratelFase1 + " "+ praticaBando1DaFirestore.codiceStatoInfratelFase2)
                }  */
          if(praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-6'  || praticaBando1DaFirestore.showFase2){
            raggruppamentoPerImpresa[impresa].totale += 1;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
               
            if(!praticaBando1DaFirestore.statoPF || praticaBando1DaFirestore.statoPF==='' || praticaBando1DaFirestore.statoPF.length < 1){
              /* if(praticaBando1DaFirestore.azienda === 'SIRTI SPA'){
                this.logger.info("PRATICA DI SIRTI SENZA PF " + praticaBando1DaFirestore.cui + " - "+praticaBando1DaFirestore.codiceStatoInfratelFase1 + " ("+praticaBando1DaFirestore.showFase2+")" + praticaBando1DaFirestore.statoFlowdyFase1 + " "+ praticaBando1DaFirestore.statoPF)
              } */

              if(!praticaBando1DaFirestore.ntwFC || praticaBando1DaFirestore.ntwFC==='' || praticaBando1DaFirestore.ntwFC.length < 1){
                raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_noNTW++;
                
              }else{
                raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_conNTW++;
                
              }
            }else {
             
              if(praticaBando1DaFirestore.statoPF==='IN ATTESA'){
                
                if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO KO'){
                  
                  /* if(praticaBando1DaFirestore.azienda === 'SIRTI SPA'){
                    this.logger.info("PRATICA DI SIRTI CON SOPRALLUOGO KO MA PF IN ATTESA " + praticaBando1DaFirestore.cui + " - "+praticaBando1DaFirestore.codiceStatoInfratelFase1 + " ("+praticaBando1DaFirestore.showFase2+")" + praticaBando1DaFirestore.statoFlowdyFase1 + " "+ praticaBando1DaFirestore.statoPF)
                  } */
                }
                if(!praticaBando1DaFirestore.ntwFC || praticaBando1DaFirestore.ntwFC==='' || praticaBando1DaFirestore.ntwFC.length < 1){
                  raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_noNTW++;
                 
                }else{
                  raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_conNTW++;
                  
                }
              }else if(praticaBando1DaFirestore.statoPF==='PRONTO'){
                if(!praticaBando1DaFirestore.dataAppuntamentoFase2){
                  raggruppamentoPerImpresa[impresa].noAppuntamentoPFPronto++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoPFPronto++;
                  
                }else{
                  if(praticaBando1DaFirestore.statoFlowdyFase2==='APPUNTAMENTO FISSATO'){
                    if(!this.checkAppuntamentoPassato(praticaBando1DaFirestore)){
                      raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoFissato++;
                     
                    }else{
                      raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoScaduto++;
                     
                    }
                  }else{
                  }
                  
                }
                
              }else if(praticaBando1DaFirestore.statoPF==='KO'){
                raggruppamentoPerImpresa[impresa].attivazioneKO++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO++;
               
              }else if(praticaBando1DaFirestore.statoPF==='ROUTER INSTALLATO'){
                raggruppamentoPerImpresa[impresa].attivazioneOK++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
                
              }else if(praticaBando1DaFirestore.statoPF==='SEDE ATTIVATA'){
                raggruppamentoPerImpresa[impresa].installazioneOK++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].installazioneOK++;
               
              }else{
                this.logger.info("[APPUNTAMENTI BANDO 1] CASO STRANO SU STATO PF "+ praticaBando1DaFirestore.cui + " STATO FLOWDY "+ praticaBando1DaFirestore.statoFlowdyFase2 + " MA CON STATO PF "+ praticaBando1DaFirestore.statoPF );
              }
            }
          }else{
            
           }
              
 
         });

          this.datiRaggruppatiBando1 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
            impresa,
            idImpresa:                      dati.idImpresa,
            totale:                         dati.totale,
            noAppuntamentoMancaPF_noNTW:    dati.noAppuntamentoMancaPF_noNTW,
            noAppuntamentoMancaPF_conNTW:   dati.noAppuntamentoMancaPF_conNTW,
            noAppuntamentoPFPronto:         dati.noAppuntamentoPFPronto,
            appuntamentoFissato:            dati.appuntamentoFissato,
            appuntamentoScaduto:            dati.appuntamentoScaduto,
            attivazioneKO:                  dati.attivazioneKO,
            attivazioneOK:                  dati.attivazioneOK,
            installazioneOK:                dati.installazioneOK,
            datiPerRegione:                 dati.datiPerRegione,
          }));
          this.datiRaggruppatiBando1Filtrati = this.datiRaggruppatiBando1;

          for (let index = 0; index < this.datiRaggruppatiBando1.length; index++) {
            this.totaliBando1                                 += this.datiRaggruppatiBando1[index].totale;
            this.totaliBando1NoAppuntamentoMancaPF_noNTW      += this.datiRaggruppatiBando1[index].noAppuntamentoMancaPF_noNTW;
            this.totaliBando1NoAppuntamentoMancaPF_conNTW     += this.datiRaggruppatiBando1[index].noAppuntamentoMancaPF_conNTW;
            this.totaliBando1NoAppuntamentoPFPronto           += this.datiRaggruppatiBando1[index].noAppuntamentoPFPronto;
            this.totaliBando1AppuntamentoFissato              += this.datiRaggruppatiBando1[index].appuntamentoFissato;
            this.totaliBando1AppuntamentoScaduto              += this.datiRaggruppatiBando1[index].appuntamentoScaduto;
            this.totaliBando1AttivazioneKO                    += this.datiRaggruppatiBando1[index].attivazioneKO;
            this.totaliBando1AttivazioneOK                    += this.datiRaggruppatiBando1[index].attivazioneOK;
            this.totaliBando1installazioneOK                  += this.datiRaggruppatiBando1[index].installazioneOK;
            
          } 
         
         
      });
    }

    loadDatiBando2(){
      this.isLoading = true;
     const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
     let queryBando2  ;
     if(this.isImpresa){
         queryBando2 = collectionRef
               .where("idAzienda", "==", this.userService.getUser().azienda.id)
               .where("bando", "==", "BANDO 2")
            //   .where("statoFlowdyFase1", "!=", "SOPRALLUOGO KO")
               .orderBy("statoFlowdyFase1")
               .orderBy("azienda",'asc');
       }else{
         queryBando2 = collectionRef
               .where("bando", "==", "BANDO 2")
           //    .where("statoFlowdyFase1", "!=", "SOPRALLUOGO KO")
               .orderBy("statoFlowdyFase1")
               .orderBy("azienda",'asc');
 
     }
     onSnapshot(queryBando2, (qs) => {
       this.isLoading = false;
       this.totaliBando2                         = 0;
       this.totaliBando2NoAppuntamentoMancaPF_noNTW    = 0;
       this.totaliBando2NoAppuntamentoMancaPF_conNTW    = 0;

       this.totaliBando2NoAppuntamentoPFPronto   = 0;
       this.totaliBando2AppuntamentoFissato      = 0;
       this.totaliBando2AppuntamentoScaduto      = 0;
       this.totaliBando2AttivazioneKO            = 0;
       this.totaliBando2AttivazioneOK            = 0;
       this.totaliBando2installazioneOK          = 0;
       const raggruppamentoPerImpresa: { 
         [key: string]: { 
           idImpresa: number,
           totale: number,
           noAppuntamentoMancaPF_noNTW : number,
           noAppuntamentoMancaPF_conNTW: number,
           noAppuntamentoPFPronto: number,
           appuntamentoFissato: number,
           appuntamentoScaduto: number,
           attivazioneKO: number,
           attivazioneOK: number,
           installazioneOK: number,
           datiPerRegione: {
             [regione: string]: {
               totale: number;
               noAppuntamentoMancaPF_noNTW : number,
               noAppuntamentoMancaPF_conNTW: number,
               noAppuntamentoPFPronto: number,
               appuntamentoFissato: number,
               appuntamentoScaduto: number,
               attivazioneKO: number,
               attivazioneOK: number,
               installazioneOK: number,
             };
           };
           
         } 
       } = {};

       qs.forEach((doc) => {
           let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
           const impresa = praticaBando2DaFirestore.azienda;
           const regione = praticaBando2DaFirestore.regione;
        
           if (!raggruppamentoPerImpresa[impresa]) {
            // 
             raggruppamentoPerImpresa[impresa] = { 
               idImpresa: praticaBando2DaFirestore.idAzienda,
               totale: 0, 
               noAppuntamentoMancaPF_noNTW: 0,
               noAppuntamentoMancaPF_conNTW: 0,
               noAppuntamentoPFPronto: 0,
               appuntamentoFissato: 0,
               appuntamentoScaduto: 0,
               attivazioneKO: 0,
               attivazioneOK: 0,
               installazioneOK: 0,
               datiPerRegione: {},
             };
           }
         if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
             raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
               totale: 0,
               noAppuntamentoMancaPF_noNTW: 0,
               noAppuntamentoMancaPF_conNTW: 0,
               noAppuntamentoPFPronto: 0,
               appuntamentoFissato: 0,
               appuntamentoScaduto: 0,
               attivazioneKO: 0,
               attivazioneOK: 0,
               installazioneOK: 0,
             };
           }
         /*   */

            if(praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-6'  || praticaBando2DaFirestore.showFase2){
                raggruppamentoPerImpresa[impresa].totale += 1;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
               
              if(!praticaBando2DaFirestore.statoPF || praticaBando2DaFirestore.statoPF==='' || praticaBando2DaFirestore.statoPF.length < 1){
                
                if(!praticaBando2DaFirestore.ntwFC || praticaBando2DaFirestore.ntwFC==='' || praticaBando2DaFirestore.ntwFC.length < 1){
                  raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_noNTW++;
                }else{
                  raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_conNTW++;
                }
              }else{
               
               
                if(praticaBando2DaFirestore.statoPF==='IN ATTESA'){
                  
                  if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO KO'){
                   /*  if(praticaBando2DaFirestore.azienda === 'SIRTI SPA'){
                      this.logger.info("PRATICA DI SIRTI CON SOPRALLUOGO KO MA PF IN ATTESA " + praticaBando2DaFirestore.cui + " - "+praticaBando2DaFirestore.codiceStatoInfratelFase1 + " ("+praticaBando2DaFirestore.showFase2+")" + praticaBando2DaFirestore.statoFlowdyFase1 + " "+ praticaBando2DaFirestore.statoPF)
                    } */
                  }
                   if(!praticaBando2DaFirestore.ntwFC || praticaBando2DaFirestore.ntwFC==='' || praticaBando2DaFirestore.ntwFC.length < 1){
                    raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_noNTW++;
                  }else{
                    raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoMancaPF_conNTW++;
                  }
                }else if(praticaBando2DaFirestore.statoPF==='PRONTO'){
                    if(!praticaBando2DaFirestore.dataAppuntamentoFase2){
                     raggruppamentoPerImpresa[impresa].noAppuntamentoPFPronto++;
                     raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noAppuntamentoPFPronto++;
                   }else{
                     if(praticaBando2DaFirestore.statoFlowdyFase2==='APPUNTAMENTO FISSATO'){
                       if(!this.checkAppuntamentoPassato(praticaBando2DaFirestore)){
                         raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                         raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoFissato++;
                       }else{
                         raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                         raggruppamentoPerImpresa[impresa].datiPerRegione[regione].appuntamentoScaduto++;
                       }
                     }else{
                       this.logger.info("CASO STRANO "+ praticaBando2DaFirestore.cui + " STATO FLOWDY "+ praticaBando2DaFirestore.statoFlowdyFase2 + " MA CON STATO PF "+ praticaBando2DaFirestore.statoPF + " E DATA APPUNTAMENTO "+praticaBando2DaFirestore.dataAppuntamentoFase2.toDate() );
                     }
                    
                   }
                   
                 }else if(praticaBando2DaFirestore.statoPF==='KO'){
                    raggruppamentoPerImpresa[impresa].attivazioneKO++;
                   raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneKO++;
                 }else if(praticaBando2DaFirestore.statoPF==='ROUTER INSTALLATO'){
                   raggruppamentoPerImpresa[impresa].attivazioneOK++;
                   raggruppamentoPerImpresa[impresa].datiPerRegione[regione].attivazioneOK++;
                 }else if(praticaBando2DaFirestore.statoPF==='SEDE ATTIVATA'){
                   raggruppamentoPerImpresa[impresa].installazioneOK++;
                   raggruppamentoPerImpresa[impresa].datiPerRegione[regione].installazioneOK++;
                 }else{
                  // this.logger.info("CASO STRANO dentro "+ praticaBando2DaFirestore.cui + " STATO FLOWDY "+ praticaBando2DaFirestore.statoFlowdyFase2 + " MA CON STATO PF "+ praticaBando2DaFirestore.statoPF );
                 }
              }
            }else{
              
          }

       });
       this.datiRaggruppatiBando2 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
        impresa,
        idImpresa:                    dati.idImpresa,
        totale:                       dati.totale,
        noAppuntamentoMancaPF_noNTW:  dati.noAppuntamentoMancaPF_noNTW, 
        noAppuntamentoMancaPF_conNTW: dati.noAppuntamentoMancaPF_conNTW, 
        noAppuntamentoPFPronto:       dati.noAppuntamentoPFPronto,
        appuntamentoFissato:          dati.appuntamentoFissato,
        appuntamentoScaduto:          dati.appuntamentoScaduto,
        attivazioneKO:                dati.attivazioneKO,
        attivazioneOK:                dati.attivazioneOK,
        installazioneOK:              dati.installazioneOK,
        datiPerRegione:               dati.datiPerRegione,

       

      }));
      this.datiRaggruppatiBando2Filtrati = this.datiRaggruppatiBando2;

      for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
        this.totaliBando2                         += this.datiRaggruppatiBando2Filtrati[index].totale;
        this.totaliBando2NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_noNTW;
        this.totaliBando2NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_conNTW;
        this.totaliBando2NoAppuntamentoPFPronto   += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoPFPronto;
        this.totaliBando2AppuntamentoFissato      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoFissato;
        this.totaliBando2AppuntamentoScaduto      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoScaduto;
        this.totaliBando2AttivazioneKO            += this.datiRaggruppatiBando2Filtrati[index].attivazioneKO;
        this.totaliBando2AttivazioneOK            += this.datiRaggruppatiBando2Filtrati[index].attivazioneOK;
        this.totaliBando2installazioneOK          += this.datiRaggruppatiBando2Filtrati[index].installazioneOK;
        
      } 
     
   });
 }

    removeFilter(){
      this.filterIsSet = false;
      this.filtroRegione = [];
       if(this.activeTabIndex==0){
        this.totaliBando1                               = 0;
        this.totaliBando1NoAppuntamentoMancaPF_noNTW    = 0;
        this.totaliBando1NoAppuntamentoMancaPF_conNTW   = 0;
        this.totaliBando1NoAppuntamentoPFPronto         = 0;
        this.totaliBando1AppuntamentoFissato            = 0;
        this.totaliBando1AppuntamentoScaduto            = 0;
        this.totaliBando1AttivazioneKO                  = 0;
        this.totaliBando1AttivazioneOK                  = 0;
        this.totaliBando1installazioneOK                = 0;

        this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiBando1];
        this.labelRegioni = "TUTTE LE REGIONI";
        for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
          this.totaliBando1                                 += this.datiRaggruppatiBando1Filtrati[index].totale;
          this.totaliBando1NoAppuntamentoMancaPF_noNTW      += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_noNTW;
          this.totaliBando1NoAppuntamentoMancaPF_conNTW     += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_conNTW;
          this.totaliBando1NoAppuntamentoPFPronto           += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoPFPronto;
          this.totaliBando1AppuntamentoFissato              += this.datiRaggruppatiBando1Filtrati[index].appuntamentoFissato;
          this.totaliBando1AppuntamentoScaduto              += this.datiRaggruppatiBando1Filtrati[index].appuntamentoScaduto; 
          this.totaliBando1AttivazioneKO                    += this.datiRaggruppatiBando1Filtrati[index].attivazioneOK; 
          this.totaliBando1AttivazioneOK                    += this.datiRaggruppatiBando1Filtrati[index].attivazioneKO; 
          this.totaliBando1installazioneOK                  += this.datiRaggruppatiBando1Filtrati[index].installazioneOK; 
        }
      }else if(this.activeTabIndex==1){
        
        this.totaliBando2                               = 0;
        this.totaliBando1NoAppuntamentoMancaPF_noNTW    = 0;
        this.totaliBando1NoAppuntamentoMancaPF_conNTW   = 0;
        this.totaliBando2NoAppuntamentoPFPronto         = 0;
        this.totaliBando2AppuntamentoFissato            = 0;
        this.totaliBando2AppuntamentoScaduto            = 0;
        this.totaliBando2AttivazioneKO                  = 0;
        this.totaliBando2AttivazioneOK                  = 0;
        this.totaliBando2installazioneOK                = 0;
        this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiBando2];
        this.labelRegioni = "TUTTE LE REGIONI";
        for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
          this.totaliBando2                         += this.datiRaggruppatiBando2Filtrati[index].totale;
          this.totaliBando1NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_noNTW;
          this.totaliBando1NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_conNTW;
          this.totaliBando2NoAppuntamentoPFPronto   += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoPFPronto;
          this.totaliBando2AppuntamentoFissato      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoFissato;
          this.totaliBando2AppuntamentoScaduto      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoScaduto; 
          this.totaliBando2AttivazioneKO            += this.datiRaggruppatiBando2Filtrati[index].attivazioneOK; 
          this.totaliBando2AttivazioneOK            += this.datiRaggruppatiBando2Filtrati[index].attivazioneKO; 
          this.totaliBando2installazioneOK          += this.datiRaggruppatiBando2Filtrati[index].installazioneOK; 
        }
          
      } 
    }

    filtraPerRegione(selezioni: string[]) {
       if(this.activeTabIndex==0){
        this.totaliBando1                         = 0;
        this.totaliBando1NoAppuntamentoMancaPF_noNTW    = 0;
        this.totaliBando1NoAppuntamentoMancaPF_conNTW   = 0;
        this.totaliBando1NoAppuntamentoPFPronto   = 0;
        this.totaliBando1AppuntamentoFissato      = 0;
        this.totaliBando1AppuntamentoScaduto      = 0;
        this.totaliBando1AttivazioneKO            = 0;
        this.totaliBando1AttivazioneOK            = 0;
        this.totaliBando1installazioneOK          = 0;
        if (!selezioni || selezioni.length === 0) {
          this.filterIsSet = false;
          this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiBando1];
          this.labelRegioni = "TUTTE LE REGIONI";
          for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
            this.totaliBando1                         += this.datiRaggruppatiBando1Filtrati[index].totale;
            this.totaliBando1NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_noNTW;
            this.totaliBando1NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_noNTW;
            this.totaliBando1NoAppuntamentoPFPronto   += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoPFPronto;
            this.totaliBando1AppuntamentoFissato      += this.datiRaggruppatiBando1Filtrati[index].appuntamentoFissato;
            this.totaliBando1AppuntamentoScaduto      += this.datiRaggruppatiBando1Filtrati[index].appuntamentoScaduto; 
            this.totaliBando1AttivazioneKO            += this.datiRaggruppatiBando1Filtrati[index].attivazioneOK; 
            this.totaliBando1AttivazioneOK            += this.datiRaggruppatiBando1Filtrati[index].attivazioneKO; 
            this.totaliBando1installazioneOK          += this.datiRaggruppatiBando1Filtrati[index].installazioneOK; 

          }
        } else {
          this.filterIsSet = true;
          if(selezioni.length == 1){
            this.labelRegioni = "REGIONE "+ selezioni[0].toUpperCase();
          }else{
            this.labelRegioni = "REGIONI " + selezioni.map(s => s.toUpperCase()).join(", ");
          }
  
          this.datiRaggruppatiBando1Filtrati = this.datiRaggruppatiBando1.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => selezioni.includes(regione))
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.noAppuntamentoMancaPF_noNTW   += regioneData.noAppuntamentoMancaPF_noNTW;
                acc.noAppuntamentoMancaPF_conNTW   += regioneData.noAppuntamentoMancaPF_conNTW;
                acc.noAppuntamentoPFPronto  += regioneData.noAppuntamentoPFPronto;
                acc.appuntamentoFissato     += regioneData.appuntamentoFissato;
                acc.appuntamentoScaduto     += regioneData.appuntamentoScaduto;
                acc.attivazioneKO           += regioneData.attivazioneKO;
                acc.attivazioneOK           += regioneData.attivazioneOK; 
                acc.installazioneOK         += regioneData.installazioneOK;
                return acc;
              }, {
                totale: 0,
                noAppuntamentoMancaPF_noNTW: 0,
                noAppuntamentoMancaPF_conNTW: 0,
                noAppuntamentoPFPronto: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                attivazioneKO: 0,
                attivazioneOK: 0,
                installazioneOK: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noAppuntamentoMancaPF_noNTW: datiFiltratiPerRegione.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW: datiFiltratiPerRegione.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto: datiFiltratiPerRegione.noAppuntamentoPFPronto,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              attivazioneKO: datiFiltratiPerRegione.attivazioneKO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => selezioni.includes(regione))
              ),
            };
          }).filter(dato => dato.totale > 0); 
          
          if(this.datiRaggruppatiBando1Filtrati.length > 0){
            for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
              this.totaliBando1                         += this.datiRaggruppatiBando1Filtrati[index].totale;
              this.totaliBando1NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_noNTW;
              this.totaliBando1NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoMancaPF_conNTW;
              this.totaliBando1NoAppuntamentoPFPronto   += this.datiRaggruppatiBando1Filtrati[index].noAppuntamentoPFPronto;
              this.totaliBando1AppuntamentoFissato      += this.datiRaggruppatiBando1Filtrati[index].appuntamentoFissato;
              this.totaliBando1AppuntamentoScaduto      += this.datiRaggruppatiBando1Filtrati[index].appuntamentoScaduto; 
              this.totaliBando1AttivazioneKO            += this.datiRaggruppatiBando1Filtrati[index].attivazioneOK; 
              this.totaliBando1AttivazioneOK            += this.datiRaggruppatiBando1Filtrati[index].attivazioneKO; 
              this.totaliBando1installazioneOK          += this.datiRaggruppatiBando1Filtrati[index].installazioneOK; 
            }
          }
        }
      }else if(this.activeTabIndex==1){
     
        this.totaliBando2                         = 0;
        this.totaliBando2NoAppuntamentoMancaPF_noNTW    = 0;
        this.totaliBando2NoAppuntamentoMancaPF_conNTW    = 0;
        this.totaliBando2NoAppuntamentoPFPronto   = 0;
        this.totaliBando2AppuntamentoFissato      = 0;
        this.totaliBando2AppuntamentoScaduto      = 0;
        this.totaliBando2AttivazioneKO            = 0;
        this.totaliBando2AttivazioneOK            = 0;
        this.totaliBando2installazioneOK          = 0;
        
        if (!selezioni || selezioni.length === 0) {
          this.filterIsSet = false;
          this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiBando2];
          this.labelRegioni = "TUTTE LE REGIONI";
          for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
            this.totaliBando2                        += this.datiRaggruppatiBando2Filtrati[index].totale;
            this.totaliBando2NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_noNTW;
            this.totaliBando2NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_conNTW;
            this.totaliBando2NoAppuntamentoPFPronto   += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoPFPronto;
            this.totaliBando2AppuntamentoFissato      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoFissato;
            this.totaliBando2AppuntamentoScaduto      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoScaduto; 
            this.totaliBando2AttivazioneKO            += this.datiRaggruppatiBando2Filtrati[index].attivazioneOK; 
            this.totaliBando2AttivazioneOK            += this.datiRaggruppatiBando2Filtrati[index].attivazioneKO; 
            this.totaliBando2installazioneOK          += this.datiRaggruppatiBando2Filtrati[index].installazioneOK; 

          }
        } else {
          this.filterIsSet = true;
          if(selezioni.length == 1){
            this.labelRegioni = "REGIONE "+ selezioni[0].toUpperCase();
          }else{
            this.labelRegioni = "REGIONI " + selezioni.map(s => s.toUpperCase()).join(", ");
          }
  
          this.datiRaggruppatiBando2Filtrati = this.datiRaggruppatiBando2.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => selezioni.includes(regione))
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.noAppuntamentoMancaPF_noNTW   += regioneData.noAppuntamentoMancaPF_noNTW;
                acc.noAppuntamentoMancaPF_conNTW   += regioneData.noAppuntamentoMancaPF_conNTW; 
                acc.noAppuntamentoPFPronto  += regioneData.noAppuntamentoPFPronto;
                acc.appuntamentoFissato     += regioneData.appuntamentoFissato;
                acc.appuntamentoScaduto     += regioneData.appuntamentoScaduto;
                acc.attivazioneKO           += regioneData.attivazioneKO;
                acc.attivazioneOK           += regioneData.attivazioneOK; 
                acc.installazioneOK         += regioneData.installazioneOK;
                return acc;
              }, {
                totale: 0,
                noAppuntamentoMancaPF_noNTW: 0,
                noAppuntamentoMancaPF_conNTW: 0,
                noAppuntamentoPFPronto: 0,
                appuntamentoFissato: 0,
                appuntamentoScaduto: 0,
                attivazioneKO: 0,
                attivazioneOK: 0,
                installazioneOK: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noAppuntamentoMancaPF_noNTW: datiFiltratiPerRegione.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW: datiFiltratiPerRegione.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto: datiFiltratiPerRegione.noAppuntamentoPFPronto,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              attivazioneKO: datiFiltratiPerRegione.attivazioneKO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => selezioni.includes(regione))
              ),
            };
          }).filter(dato => dato.totale > 0); 
          
          if(this.datiRaggruppatiBando2Filtrati.length > 0){
            for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
              this.totaliBando2                         += this.datiRaggruppatiBando2Filtrati[index].totale;
              this.totaliBando2NoAppuntamentoMancaPF_noNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_noNTW;
              this.totaliBando2NoAppuntamentoMancaPF_conNTW    += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoMancaPF_conNTW;
              this.totaliBando2NoAppuntamentoPFPronto   += this.datiRaggruppatiBando2Filtrati[index].noAppuntamentoPFPronto;
              this.totaliBando2AppuntamentoFissato      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoFissato;
              this.totaliBando2AppuntamentoScaduto      += this.datiRaggruppatiBando2Filtrati[index].appuntamentoScaduto; 
              this.totaliBando2AttivazioneKO            += this.datiRaggruppatiBando2Filtrati[index].attivazioneOK; 
              this.totaliBando2AttivazioneOK            += this.datiRaggruppatiBando2Filtrati[index].attivazioneKO; 
              this.totaliBando2installazioneOK          += this.datiRaggruppatiBando2Filtrati[index].installazioneOK; 
            }
          }
        }
      

      } 
      
    }
    

   
  
  
}
